import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

// Several detail pages only receive their data via router `state` (passed from
// the list page that navigated here). If this page is loaded without that
// state - e.g. a browser refresh, a direct link, or back/forward navigation -
// `state` is null and the page has nothing to render. This hook detects that
// case and bounces back to `fallbackRoute` instead of crashing on a null
// dereference.
// Default kept loose on purpose: at least one call site
// (checking_account_detail_page.tsx) relies on it rather than a real DTO,
// see the note there.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function useDetailState<T = any>(fallbackRoute: string): T | null {
  const { state } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (state == null) navigate(fallbackRoute, { replace: true });
  }, [state, navigate, fallbackRoute]);

  return state as T | null;
}
